import { useEffect, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import { useLenis } from '../components/SmoothScroll/SmoothScroll';

function ScrollToTop({ history }) {
  const lenis = useLenis();
  const prevPath = useRef(window.location.pathname);

  useEffect(() => {
    const unlisten = history.listen((location) => {
      if (location.pathname === prevPath.current) return;
      prevPath.current = location.pathname;
      if (lenis) {
        lenis.scrollTo(0, { immediate: true });
      } else {
        window.scrollTo(0, 0);
      }
    });
    return () => unlisten();
  }, [history, lenis]);

  return null;
}

export default withRouter(ScrollToTop);
